// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/* eslint-disable */
import Vue from 'vue'
import App from './App'
import {Toast} from "mint-ui"
import GoodsCoupon from '@/components/goodsCoupon/goodsCoupon'
import Editor from '@/components/goodsNav/editor' //小编推荐
import Hot from '@/components/goodsNav/hot' //热销版
import Brand from '@/components/goodsNav/brand' //品牌券
import HighQuality from '@/components/goodsNav/highQuality' //优选大券
import Nine from '@/components/goodsNav/nine' //9.9
import Twenty from '@/components/goodsNav/twenty' //20封顶
import SeaNaughty from '@/components/goodsNav/seaNaughty' //海淘
import Jhs from '@/components/goodsNav/jhs' //聚划算
import GrapBuying from '@/components/goodsNav/grapBuying' //淘抢购
import Search from '@/components/search/search'
import UserCenter from '@/components/userCenter/userCenter/userCenter'
import Welfare from '@/components/welfare/welfare'
import Quan from '@/components/quan/quan'
import SearchResulte from '@/components/search/searchResulte'
import Item from '@/components/item/item'
import WfItem from '@/components/welfare/item'
import Paper from '@/components/quan/paper'
import User from '@/components/quan/user'
import NewPaper from '@/components/quan/newPaper'
import Login from '@/components/login/login'
//个人中心链接
import Mall from '@/components/userCenter/mall/mall'
import MallItem from '@/components/userCenter/mall/mallItem'
import News from '@/components/userCenter/news/news'
import BuyScoreMallGoodRecord from '@/components/userCenter/buyScoreMallGoodRecord'
import MyBuyScoreMallGoodRecord from '@/components/userCenter/myBuyScoreMallGoodRecord'
import GetCoinsWays from '@/components/userCenter/getCoinsWays'
import OrderScore from '@/components/userCenter/orderScore'
import Help from '@/components/userCenter/help' //淘抢购
import CoinsCenter from '@/components/userCenter/coinsCenter' //淘抢购
import PromotePost from '@/components/userCenter/PromotePost' //分享赚券币
import CouponFan from '@/components/userCenter/couponFan' //领券实况
import BePromoter from '@/components/userCenter/BePromoter' //成为合伙人
//推广中心
import MyUser from '@/components/userCenter/myUser' //我的用户
import MyOrderList from '@/components/userCenter/myOrderList' //我的业绩
import MyPromoters from '@/components/userCenter/myPromoters' //我的推广员
import MyRanking from '@/components/userCenter/myRanking' //排行榜
//消息中心子路由
import SystemNotify from '@/components/userCenter/news/systemNotify'
import GetCoins from '@/components/userCenter/news/getCoins'
import Discuss from '@/components/userCenter/news/discuss'
import VueRouter from 'vue-router'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css' //最嗨的是他这个直接引入的是一个css文件
import axios from 'axios'
Vue.use(Mint)
Vue.use(VueRouter)
import {
  addScore
} from "./common/js/common.js"
import './api/api.js'
//import './http/vconsole.js'
Vue.config.productionTip = false

//vuex状态管理
import store from './vuex/index.js'

/* eslint-disable no-new */
const routes = [{
    path: '/',
    redirect: '/goodsCoupon', //设置默认指向的路径
    name: '首页'
  },
  {
    path: '/goodsCoupon',
    component: GoodsCoupon,
    name: "goodsCoupon"
  },
  {
    path: '/goodsNav/editor',
    component: Editor,
    name: "editor"
  }, //小编推荐
  {
    path: '/goodsNav/hot',
    component: Hot,
    name: "hot"
  }, //热销版
  {
    path: '/goodsNav/brand',
    component: Brand,
    name: "brand"
  }, //品牌券
  {
    path: '/goodsNav/highQuality',
    component: HighQuality,
    name: "highQuality"
  }, //优选大券
  {
    path: '/goodsNav/nine',
    component: Nine,
    name: "nine"
  }, //9.9专区Twenty
  {
    path: '/goodsNav/twenty',
    component: Twenty,
    name: "twenty"
  }, //20元封顶专区
  {
    path: '/goodsNav/jhs',
    component: Jhs,
    name: "jhs"
  }, //聚划算
  {
    path: '/goodsNav/grapBuying',
    component: GrapBuying,
    name: "grapBuying"
  }, //淘抢购
  {
    path: '/goodsNav/seaNaughty',
    component: SeaNaughty,
    name: "seaNaughty"
  },
  {
    path: '/search',
    component: Search,
    name: "search"
  },
  {
    path: '/welfare',
    component: Welfare,
    name: "welfare"
  },
  {
    path: '/quan',
    component: Quan,
    name: "quan",
    meta:{auth:true}
  },
  {
    path: '/userCenter',
    component: UserCenter,
    name: "userCenter",
    meta:{auth:true}
  },
  {
    path: '/searchResulte',
    component: SearchResulte,
    name: "searchResulte"
  },
  {
    path: '/item/:id',
    component: Item,
    name: "item"
  },
  {
    path: '/welfare/item/:id',
    component: WfItem,
    name: "welfareItem"
  },
  {
    path: '/quan/paper/:paperid',
    component: Paper,
    name: "quanItem"
  },
  {
    path: '/quan/user/:openid',
    component: User,
    name: "user"
  },
  {
    path: '/quan/newPaper',
    component: NewPaper,
    name: "newPaper"
  },
  {
    path: '/login/Login',
    component: Login,
    name: "login"
  },
  //个人中心
  {
    path: '/userCenter/mall/mall',
    component: Mall,
    name: "mall"
  },
  {
    path: '/userCenter/mall/mallItem/:id',
    component: MallItem,
    name: "mallItem"
  },
  {
    path: '/userCenter/news/news',
    component: News,
    name: "news",
    children: [{
        path: '/news/systemNotify',
        component: SystemNotify
      },
      {
        path: '/news/getCoins',
        component: GetCoins
      },
      {
        path: '/home/discuss',
        component: Discuss
      }
    ],
    redirect: '/home/discuss'
  },
  {
    path: '/userCenter/myBuyScoreMallGoodRecord',
    component: MyBuyScoreMallGoodRecord,
    name: "myBuyScoreMallGoodRecord"
  },
  {
    path: '/userCenter/buyScoreMallGoodRecord',
    component: BuyScoreMallGoodRecord,
    name: "buyScoreMallGoodRecord"
  },
  {
    path: '/userCenter/getCoinsWays',
    component: GetCoinsWays,
    name: "getCoinsWays"
  },
  {
    path: '/userCenter/orderScore',
    component: OrderScore,
    name: "orderScore"
  },
  {
    path: '/userCenter/help',
    component: Help,
    name: "help" //帮助
  },
  {
    path: '/userCenter/coinsCenter',
    component: CoinsCenter,
    name: "CoinsCenter" //券币记录
  },
  {
    path: '/userCenter/promotePost',
    component: PromotePost,
    name: "promotePost" //券币记录
  },
  {
    path: '/userCenter/couponFan',
    component: CouponFan,
    name: "couponFan" //领券实况
  },
  //推广中心
  {
    path: '/userCenter/myUser',
    component: MyUser,
    name: "myUser" //我的用户
  },
  {
    path: '/userCenter/myOrderList',
    component: MyOrderList,
    name: "MyOrderList" //我的业绩
  },
  {
    path: '/userCenter/myPromoters',
    component: MyPromoters,
    name: "myPromoters" //我的推广员
  },
  {
    path: '/userCenter/myRanking',
    component: MyRanking,
    name: "myRanking" //排行榜
  },
  {
    path: '/userCenter/bePromoter',
    component: BePromoter,
    name: "bePromoter" //排行榜
  },
]

const router = new VueRouter({
  //'mode':'history',
  //mode:'history',
  routes, // （缩写）相当于 routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },


})
router.beforeEach((to, from, next) => {
  if (!sessionStorage.islogged || !JSON.parse(sessionStorage.islogged)) {
    let url = "gzh/sqw/getUserInfo.php"
    Vue.prototype.$ajax.autoService
      .login(url).then((res) => {
        //console.log(res)
        // res.data = {
        //   appid: "wx64c594fbcfb9feb8",
        //   avatarUrl: "http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eokJTRwsdzAh3Nqgee3Yj97l9Dmcqv7IrbznMiazZ5WwzTWiaCEFxW9ibyXQYvyvg4LQw6OFkQa4nT3A/132",
        //   city: "长沙",
        //   country: "中国",
        //   gender: "2",
        //   nikeName: "土匪妹妹",
        //   openId: "oTLarw7dMe7cPjnuMggSkIkp0RWg",
        //   province: "湖南",
        //   totalScore: "0",
        //   usedScore: "0",
        //   userCreateTime: "2018-08-03 11:05:11",
        // }
        if (res.data.openId) {
          store.state.userInfo = res.data;
          sessionStorage.islogged = true;
          sessionStorage.setItem('userInfo', JSON.stringify(res.data));
          store.dispatch('getScoreUserInfo')
          store.dispatch('hasSign')

          next()
          //console.log(this.state.userInfo.openId)
        } else {
          sessionStorage.islogged = false
          if(to.matched.some( m => m.meta.auth)){
            Toast({
              message:"请先关注搜券王微信公众号，才可以进入这个页面"
            })
            console.log(from.path)
            if(from.path){
              next(from.path)
            }
            else{
              next('/')
            }

          }
          else{
            next()
          }
        }


      }, (res) => {
        console.log("error")
      })
  } else {
    next()
  }
  //分享配置
  var url=window.location.href.split('#')[0]; //当前网址
  Vue.prototype.$ajax.autoService.
    postData('gzh/sqw/share_jssdk.php',{Url:url}).then((res)=>{
      wx.config({
        debug: false,
        appId: res.data.appId,
        timestamp: res.data.timestamp,
        nonceStr: res.data.nonceStr,
        signature: res.data.signature,
        jsApiList: [
          // 所有要调用的 API 都要加到这个列表中
          'onMenuShareAppMessage',//朋友
          'onMenuShareTimeline',//朋友圈
          'onMenuShareQQ',
          'onMenuShareQZone',
          'onMenuShareWeibo',
        ]
    });
    },(data)=>{
      Toast({
        message:"连接失败"
      })
    })

  wx.ready(function (){
    var title = '搜券王，搜到就是赚到';
    var desc = '把你心动的商品，分享给你心仪的朋友';
    var linkurl = window.location.href.split('#')[0] +'#'+ window.location.href.split('#')[1];
    console.log(linkurl)

     //分享给好友
     wx.onMenuShareAppMessage({
              title: title, // 分享标题
              desc: desc, // 分享描述
              link: window.location.href.split('#')[0]+'#'+window.location.href.split('#')[1], // 分享链接！这里是关键 因为微信会把我们分享的链接截取掉 我在这里手动拼接上
              imgUrl: '', // 分享图标
              type: '', // 分享类型,music、video或link，不填默认为link
              dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function () {
                addScore('分享给微信好友', JSON.parse(sessionStorage.userInfo).openId, function (score) {

          }, function () {
          })
                console.log('已分享给好友');
              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
              },
              fail: function (res) {
                window.alert(JSON.stringify(res));
              }
            });

    // wx.onMenuShareAppMessage({
    //   title: title, // 分享标题
    //   desc: desc, // 分享描述
    //   link: linkurl, // 分享链接
    //   imgUrl: imgurl, // 分享图标
    //   type: '', // 分享类型,music、video或link，不填默认为link
    //   dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
    // });

    //分享到朋友圈
    wx.onMenuShareTimeline({
      title: title, // 分享标题
      link: linkurl, // 分享链接
    });

    //qq
    wx.onMenuShareQQ({
    	title: title, // 分享标题
    	desc: desc, // 分享描述
    	link: linkurl, // 分享链接
    });

    //qq空间
    wx.onMenuShareQZone({
    	title: title, // 分享标题
    	desc: desc, // 分享描述
    	link: linkurl, // 分享链接
    });

    //腾讯微博
    wx.onMenuShareWeibo({
    	title: title, // 分享标题
    	desc: desc, // 分享描述
    	link: linkurl, // 分享链接
    });





  });
  //分享错误处理
  wx.error(function(res){
    alert("系统刚才脑子进水了，暂不支持分享，想分享，请重新打开页面再试试！");
  });

  //console.log(JSON.parse(sessionStorage.userInfo))

})


//router.push('/search')
//router.push('/goodsCoupon')
//router.push('/goodsNav/grapBuying')

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js